import { ShaderMaterial } from "three";
// These tune Three.js' reduced SMAA shader, not the full official SMAA presets.
export const SMAA_QUALITY_SETTINGS = {
    low: { threshold: 0.15, searchSteps: 4 },
    medium: { threshold: 0.1, searchSteps: 8 },
    high: { threshold: 0.025, searchSteps: 32 }
};
export const SMAA_PREFERENCE_SCHEMA = {
    smaaQuality: { type: "string", default: "medium" }
};
export function getSmaaQuality(preferences) {
    const value = preferences.getPreferredValue("smaaQuality", "medium");
    return value === "low" || value === "high" ? value : "medium";
}
export function applySmaaQuality(pass, quality) {
    // r185 keeps these materials internal; guard the runtime API against upstream changes.
    if (!("_materialEdges" in pass) ||
        !(pass._materialEdges instanceof ShaderMaterial) ||
        !("_materialWeights" in pass) ||
        !(pass._materialWeights instanceof ShaderMaterial)) {
        throw new Error("The installed Three.js SMAAPass does not expose the expected shader materials");
    }
    const settings = SMAA_QUALITY_SETTINGS[quality];
    const edges = pass._materialEdges;
    const weights = pass._materialWeights;
    if (edges.defines.SMAA_THRESHOLD !== settings.threshold.toString()) {
        edges.defines.SMAA_THRESHOLD = settings.threshold.toString();
        edges.needsUpdate = true;
    }
    if (weights.defines.SMAA_MAX_SEARCH_STEPS !== settings.searchSteps.toString()) {
        weights.defines.SMAA_MAX_SEARCH_STEPS = settings.searchSteps.toString();
        weights.needsUpdate = true;
    }
}
